<section class="content-container">
	@if (isUserPage() && specialistRead()) {
		<lvr-specialists-overview style="padding: 0 0px 16px 0px" [page]="itemsPage()"></lvr-specialists-overview>
	} @else if (canReadClients()) {
		<lvr-client-view style="padding: 0 0px 16px 0px" [page]="itemsPage()"></lvr-client-view>
	}

	@if (canShowNetworkContactOverview()) {
		<lvr-network-contact-overview lvrPadding [padVertical]="0"></lvr-network-contact-overview>
	}
</section>
